import { Choice } from '@model';

export class ChoiceFilter {
  selection: Choice;
  selected: string[];
}
